import { z } from 'zod'
import { optionalString, requiredString, timestampedDocSchema } from '../utils/basicSchemas/document.z.schema'
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'


const messagesSchema = z.object({
    participants: z.array(mongoId("Participant id")),
})

// Not used in validation yet ....
const messagesIdSchema = z.object({
    id: mongoId("messages id"),
})


const messagesValidator = new ZSchema(
    { bodySchema: messagesSchema }
)


// TODO: UNTESTED:
export { messagesValidator }
